
import { Component, Vue } from 'vue-property-decorator';
import _ from 'lodash';
import LogoutBtn from '@/components/header/LogoutBtn.vue';
import ToggleThemeBtn from '@/components/header/ToggleThemeBtn.vue';
import ToggleWsPopupsBtn from '@/components/header/ToggleWsPopupsBtn.vue';
import Notifications from '@/components/header/Notifications.vue';
import { modLabel } from '@/components/global-palette/hotkeys';

@Component({
  components: {
    Notifications,
    ToggleThemeBtn,
    ToggleWsPopupsBtn,
    LogoutBtn,
  },
})
export default class DashboardCoreAppBar extends Vue {
  get jumpHint(): string {
    return `${modLabel()}+K`;
  }

  get username(): string {
    return this.$store.state.user.username || 'Guest';
  }

  get email(): string {
    const email = this.$store.state.user.email || '';
    if (!email || email === 'Guest@Guest.guest') {
      return '';
    }
    return email;
  }

  public openJumpPalette(): void {
    this.$root.$emit('open-global-palette');
  }

  get pageName(): string {
    if (this.$route?.meta?.title && !this.$route.name) {
      return this.$route.meta.title;
    } else if (this.$route.name) {
      return _.startCase(_.toLower(this.$route.name));
    }

    return _.startCase(_.toUpper(_.trim(this.$route.path, '/')));
  }

  get isMobile(): boolean {
    return this.$vuetify.breakpoint.smAndDown;
  }

  get drawer(): boolean {
    return this.$store.state.drawer.visible;
  }

  get mini(): boolean {
    return !!this.$store.state.drawer.mini;
  }

  get drawerButtonIcon(): string {
    if (this.isMobile) {
      return this.drawer ? 'mdi-menu-open' : 'mdi-menu';
    }

    return this.mini ? 'mdi-menu' : 'mdi-menu-open';
  }

  get drawerButtonTooltip(): string {
    if (this.isMobile) {
      return this.drawer ? 'Close menu' : 'Open menu';
    }

    return this.mini ? 'Expand menu' : 'Collapse menu';
  }

  private onDrawerButtonClick(): void {
    if (this.isMobile) {
      this.$store.commit('SET_DRAWER', !this.$store.state.drawer.visible);
      return;
    }

    this.$store.commit('TOGGLE_DRAWER_MINI');
    if (!this.$store.state.drawer.visible) {
      this.$store.commit('SET_DRAWER', true);
    }
  }
}
